import React, { useEffect, useState } from "react";
import { getDocs, collection, query, orderBy, where, deleteDoc, doc, getDoc, setDoc} from "firebase/firestore";
import ConfessionCard from "../utilities/components/ConfessionCard"
import ConfessionCardSkelton from "../utilities/components/ConfessionCardSkelton"
import { auth, db } from "../config/FirebaseConfig";
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import DeleteIcon from '@mui/icons-material/Delete';
import Skeleton from '@mui/material/Skeleton';
import useStore from "../store";



function MyConfessions({isAuth}) {

  const userData = useStore((state) => state.userData);


  const [postLists, setPostList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const postsCollectionRef = collection(db, "posts");


  const deletePost = async (id, catCode) => {
    const postDoc = doc(db, "posts", id);
    await deleteDoc(postDoc);
    let postListsFiltered = postLists.filter(post => post.id != id);

    //Decrement count_posts by 1
    let sfuIdInCountCollection = 'T0h0L5acIUJ9zRnZ30AO'
    let posts_count = 'posts_count'
    const docRef = doc(db, posts_count, sfuIdInCountCollection);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      console.log("Document data:", docSnap.data());
      let countObject = {
        count_posts: docSnap.data().count_posts - 1,
      }
      let oldCategoryCount = docSnap.data()[catCode]
      countObject[catCode] = oldCategoryCount - 1
      await setDoc(doc(db, posts_count, sfuIdInCountCollection), countObject, { merge: true });

    } else {
      console.log("No document for count");
    }

    setPostList(postListsFiltered)
  };


  useEffect(() => {
    const getPosts = async () => {
      const data = await getDocs(query(postsCollectionRef, orderBy("date", "desc"), where('author.id', '==', userData.uid)));
      setPostList(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
      setIsLoading(false)
    };

    getPosts();
    console.log("frrrrr: ", userData.uid)
  }, []);


  return (
    <Grid container>
      <Box 
        sx={{ width: '100%' }}
        display="flex"
        justifyContent="center"
        //className={styles.mainBox}
      >
        <Grid item xs={11} sm={9} md={6}>
          {!isLoading ? 
            postLists.length ?
              postLists.map((post) => {
              return(
                <ConfessionCard
                  text={post.text}
                  date={post.date}
                  name={post.author && post.author.name}
                  displayIconRight={<DeleteIcon onClick={() => deletePost(post.id, post.categoryCode)}/>}
                  isLikeGroupDisabled={true}
                  isAuth={isAuth}
                  likedByIds={post.likedBy}
                  disLikedByIds={post.disLikedBy}
                  post_id={post.id}
                />
              )
            })
            :
            <h4>You haven't added your first confession!</h4>
          :
            [<ConfessionCardSkelton/>,
            <ConfessionCardSkelton/>,
            <ConfessionCardSkelton/>]
        }
        </Grid>
      </Box>
    </Grid>
  );
}

export default MyConfessions;
